import { AvvirEvent } from "type_aliases";
import { ApiPipeline } from "avvir";

export type ProjectPipelinesLoadedEvent = AvvirEvent<typeof PROJECT_PIPELINES_LOADED, {
  projectId: string
  pipelines: ApiPipeline[]
}>

const projectPipelinesLoaded = (projectId: string, pipelines: ApiPipeline[]): ProjectPipelinesLoadedEvent => ({
  type: PROJECT_PIPELINES_LOADED,
  payload: {
    projectId,
    pipelines
  }
});

export const PROJECT_PIPELINES_LOADED = "project_pipelines_loaded";

export default projectPipelinesLoaded;
